/**
 *
 * loginErrorKey
 * Map a failed API login to the key of the message that explains it.
 *
 */

import { statusOf } from './loginWithFirebase';

// The API could not be reached or failed: the Firebase sign-in is fine, so
// the user keeps it and can retry
export const LOGIN_FAILED = 'loginFailed';

export default function loginErrorKey(error) {
  const status = statusOf(error);
  if (status === 403) {
    return 'notVerified';
  }
  if (status === 401) {
    return 'error';
  }
  return LOGIN_FAILED;
}
